import React from 'react';
import { StyledButton } from './NetWorthLink.styles';
import { Icon } from '../../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../../../CommonUtils/formatNumber';

interface Props {
  netWorth: number;
  onClick(): void;
}

export const NetWorthLink = ({ netWorth, onClick }: Props) => {
  return (
    <StyledButton onClick={onClick}>
      <Icon className="far fa-sack-dollar" color="neutral.400" />
      <Text fontWeight={600} ml="8">
        Net Worth
      </Text>

      <Text variant="tabular" fontWeight={600} ml="auto" mr="8">
        {formatCurrency(netWorth)}
      </Text>
      <Icon className="fas fa-chevron-right" color="neutral.400" />
    </StyledButton>
  );
};
